
export interface IToastMessage {
  title?: string,
  type?: ToastType,
  message: string,
  seconds?: number
}

export class ToastModel {
  public visible: boolean;
  public title: string;
  public message: string;
  public type: ToastType;

  constructor(visible: boolean, toastMessage?: IToastMessage) {
    this.visible = visible;
    this.title = toastMessage?.title ?? '';
    this.type = toastMessage?.type ?? ToastType.Info;
    this.message = toastMessage?.message ?? '';
  }

  get cssClass(): string {
    let out = this.visible ? ['show'] : [];
    if (this.type != ToastType.None) {
      out.push(`text-bg-${String(this.type)}`);
    }
    return out.join(' ');
  }
}

export enum ToastType {
  Info = 'info',
  Error = 'danger',
  Success = 'success',
  Warning = 'warning',
  None = 'none'
}

